export const SET_PRODUCTS = 'SET_PRODUCTS'

const initialState = {
  products: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.products
      }
    default:
      return state
  }
}
